import { Injectable, inject } from '@angular/core';
import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { Actions, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfigActions, GetConfigSuccessAction } from './config.action';
import { EnumEnvs } from './config.interface';
import * as ConfigSelectors from './config.selectors';

@Injectable({ providedIn: 'root' })
export class ConfigFacade {
  protected store = inject<Store<SettingsState>>(Store);
  protected actions$ = inject(Actions);

  config$ = this.store.pipe(select(ConfigSelectors.getAllConfig));
  appId$ = this.store.pipe(select(ConfigSelectors.getAppId));
  appPrefix$ = this.store.pipe(select(ConfigSelectors.getAppPrefix));
  environment$ = this.store.pipe(select(ConfigSelectors.getEnvironment));
  isProductionEnv$ = this.environment$.pipe(map(env => env === EnumEnvs.PRODUCTION));
  isBetaEnv$ = this.environment$.pipe(map(env => env === EnumEnvs.BETA));
  isIntegrationEnv$ = this.environment$.pipe(map(env => env === EnumEnvs.INTEGRATION));
  isLocalEnv$ = this.environment$.pipe(map(env => env === EnumEnvs.LOCAL));
  webappMode$ = this.store.pipe(select(ConfigSelectors.getWebappMode));
  darkModeEnabled$ = this.store.pipe(select(ConfigSelectors.darkModeEnabled));

  private dispatch(action: Action): void {
    this.store.dispatch(action);
  }

  loadConfig(): Observable<GetConfigSuccessAction> {
    this.dispatch(ConfigActions.getConfig());
    return this.actions$.pipe(
      ofType(ConfigActions.getConfigSuccess),
    );
  }

  setDarkModeStatus(status: boolean): void {
    status = status || false;
    this.dispatch(ConfigActions.setDarkModeStatus({ status }));
  }

  setWebappMode(): void {
    this.dispatch(ConfigActions.setWebappMode());
  }

  getWebappMode(): boolean {
    let webappMode = false;
    this.webappMode$.pipe(take(1))
      .subscribe(m => webappMode = m);
    return webappMode;
  }
}
